<template>
    <div class="text_area_block">
        <div class="flex flex-row items-center gap-2 action_block">
            <ActionButtons @removeFormElement="remove_form_element" />
        </div>
        <div v-if="data.label" class="mb-2">{{ data.label }}</div>
        <div :class="['input_box',{preview:preview}]">
            <textarea></textarea>
        </div>
    </div>
</template>
<script setup>
    import ActionButtons from '../ActionButtons'
    const emit = defineEmits(['modifyFormElement','removeFormElement'])
    const props = defineProps({
        data: Object,
        index: Number,
        preview: Boolean
    })

    const remove_form_element = () => {
        emit('removeFormElement', props.index)
    }
</script>
<style lang="scss" scoped> 
    .text_area_block{
        display: block;
        position: relative;        
        & > .input_box{
            textarea{
                pointer-events: none;
                padding: 10px;
                width: 100%; border: 1px solid #ddd;
                border-radius: 5px;
            }
            &.preview > textarea{
                pointer-events: all;
            }
        }
    }
</style>